import React, { useState, useEffect, useRef } from "react";

import BcSepIcon from "../../asset/images/about/breadcrumb-separator.svg";

// Desktop + Mobile hero images — imported separately
import HeroBgImg       from "../../asset/images/products/esp-controls/hero-bg.webp";
import HeroBgImgMobile from "../../asset/images/products/esp-controls/hero-bg-mobile.webp";

import SlideImg1 from "../../asset/images/products/esp-controls/slide-1.webp";
import SlideImg2 from "../../asset/images/products/esp-controls/slide-2.webp";
import SlideImg3 from "../../asset/images/products/esp-controls/slide-3.webp";


import FeaturesTabIcon from "../../asset/images/products/1-phase/features-icon.svg";
import CubicleTabIcon  from "../../asset/images/products/esp-controls/cubicle-icon.svg";


const SLIDES = [SlideImg1, SlideImg2, SlideImg3];
const AUTOPLAY_SPEED = 3000;

/* Salient features — bold segments encoded as { text, bold } arrays */
const SALIENT_FEATURES = [
  [{ text: "Integrated controller enables fine control of transformer parameters, Power Down /Controlled Rapping, heaters & other auxiliaries." }],
  [{ text: "Built-in " }, { text: "Charge-ratio OPACITY OPTIMIZATION", bold: true }, { text: " with a higher rate upto 1:999" }],
  [{ text: "Built-in " }, { text: "Power Down / Control Rapping software to reduce back corona & achieve cleaner collecting Plates", bold: true }],
  [{ text: "Built-in " }, { text: "AUTO-OPTIMIZATION SOFTWARE", bold: true }, { text: " based on sophisticated & advanced features like intermittent energization; the optimization mode enables large-scale energy savings." }],
  [{ text: "Built-in redundancy " }, { text: "Automatic changeover to manual control with full spark, arc and over-current facilities should main processor fail", bold: true }],
  [{ text: "Serial interface (CANBUS protocol) for communication ensures easy & efficient connectivity to plant DCS or PLC" }],
  [{ text: "Computer-aided ESP control management system" }],
  [{ text: "Fully-customized Control cabinets" }],
  [{ text: "Proven capability to interface with all known ESP controllers available throughout the globe", bold: true }],
  [{ text: "Option of Stand-alone as well as cascade arrangements" }],
  [{ text: "Password protected to prevent unauthorized access & tampering of settings" }],
  [{ text: "Conforms to IP-65 as per IEC PUB 947-1 / NEMA Type 12" }],
];

const CUBICLE_OPTIONS = [
  [{ text: "Fully Customized Control Cabinets " }],
  [{ text: "Options for Stand Alone Panels as well as cascaded arrangement. " }],
  
  [{ text: "IP 54 : Upto 160A Input Current " , bold: true}],
  [{ text: "IP 31 : For Input Current More than 160A   ", bold: true }],
    [{ text: "Conforms to IP-65 as per IEC PUB 947-1 / NEMA Type 12 " }],
    
  
];

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .espc-wrap { font-family: 'Poppins', sans-serif; color: #202020; background: #fff; }

  /* ══════════════════════════════════════════
     1. HERO
  ══════════════════════════════════════════ */
  .espc-hero {
    position: relative;
    width: 100%;
    height: 460px;
    overflow: hidden;
    background: #111;
  }
  .espc-hero-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
  }
  .espc-hero-bg-mobile {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: none;
  }
  .espc-hero-overlay {
    position: absolute;
    inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.78) 0%,
    //   rgba(0,0,0,0.45) 45%,
    //   rgba(0,0,0,0.05) 100%
    // );
  }
  .espc-hero-content {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 102px;
    max-width: 1600px;
    margin: 0 auto;
    left: 0; right: 0;
  }
  .espc-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px;
    font-weight: 700;
    color: #fff;
    line-height: 120%;
    margin-bottom: 15px;
  }
  .espc-hero-divider {
    width: 320px;
    height: 2px;
    background: #EB2019;
    border: none;
    margin-bottom: 18px;
  }
  .espc-hero-desc {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 150%;
    max-width: 400px;
  }

  /* ══════════════════════════════════════════
     2. BREADCRUMB
  ══════════════════════════════════════════ */
  .espc-breadcrumb {
    padding: 40px 0 0 0;
  }
  .espc-breadcrumb-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
  }
  .espc-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #202020;
    text-decoration: none;
    transition: color 0.15s;
  }
  .espc-bc-item:hover { color: #EB2019; }
  .espc-bc-item.espc-active { color: #202020; }
  .espc-bc-sep {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin: 0 8px;
    flex-shrink: 0;
  }

  /* ══════════════════════════════════════════
     SHARED INNER
  ══════════════════════════════════════════ */
  .espc-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
  }

  /* ══════════════════════════════════════════
     3. CONTENT — left text + right slider
  ══════════════════════════════════════════ */
  .espc-section-content {
    padding: 80px 0 120px 0;
  }
  .espc-content-grid {
    display: flex;
    gap: 90px;
    align-items: center;
  }
  .espc-content-left {
    flex: 0 0 594px;
  }
  .espc-red-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #EB2019;
    margin-bottom: 14px;
    line-height: 140%;
  }
  .espc-para {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 140%;
  }
  .espc-para + .espc-para { margin-top: 14px; }

  /* Slider */
  .espc-slider {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 14px;
  }
  .espc-slider-img-wrap {
    width: 100%;
    height: 500px;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    cursor: grab;
    user-select: none;
  }
  .espc-slider-img-wrap:active { cursor: grabbing; }
  .espc-slider-track {
    display: flex;
    height: 100%;
    transition: transform 0.6s ease;
  }
  .espc-slider-track .espc-slider-img {
    min-width: 100%;
    flex-shrink: 0;
  }
  .espc-slider-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
  .espc-slider-dots {
    display: flex;
    justify-content: center;
    gap: 8px;
  }
  .espc-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #B8B7B7;
    border: none;
    cursor: pointer;
    padding: 0;
    transition: background 0.2s;
  }
  .espc-dot.espc-dot-active { background: #EB2019; }

  /* ══════════════════════════════════════════
     4. TABS SECTION  (2-tab: Features / Cubicle)
  ══════════════════════════════════════════ */
  .espc-tabs-section {
    padding: 0 0 120px 0;
  }

  .espc-tabs-bar {
    display: flex;
    margin-bottom: 42px;
    overflow: visible;
  }

  /* Active tab */
  .espc-tab-active {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 14px;
    padding: 18px 24px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 500;
    background: #B91E1A;
    color: #fff;
    border: none;
    cursor: pointer;
    position: relative;
    transition: background 0.2s;
    white-space: nowrap;
  }
  .espc-tab-active::after {
    content: '';
    position: absolute;
    bottom: -13px;
    left: 50%;
    transform: translateX(-50%);
    border-left: 13px solid transparent;
    border-right: 13px solid transparent;
    border-top: 13px solid #B91E1A;
    z-index: 2;
  }

  /* Inactive tab */
  .espc-tab-inactive {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 14px;
    padding: 20px 24px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 400;
    background: #F1F1F1;
    color: #202020;
    border: none;
    cursor: pointer;
    transition: background 0.2s, color 0.2s;
    white-space: nowrap;
  }
  .espc-tab-inactive:hover { background: #e4e4e4; }

  .espc-tab-icon {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
  }
  .espc-tab-active .espc-tab-icon   { filter: brightness(0) invert(1); }
  .espc-tab-inactive .espc-tab-icon { filter: brightness(0); }

  /* ── Features / Cubicle list ── */
  .espc-features-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .espc-features-list li {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 160%;
    padding: 4px 0 4px 22px;
    position: relative;
  }
  .espc-features-list li::before {
    content: '•';
    position: absolute;
    left: 0;
    color: #202020;
  }
  .espc-features-list li b {
    font-weight: 600;
  }

  /* ══════════════════════════════════════════
     RESPONSIVE — TABLET 768px
  ══════════════════════════════════════════ */
  @media (max-width: 768px) {
    .espc-hero              { height: 300px; }
    .espc-hero-bg           { display: block; }
    .espc-hero-bg-mobile    { display: none; }
    .espc-hero-content      { padding: 0 32px; }
    .espc-hero-title        { font-size: 30px; }
    .espc-hero-divider      { width: 260px; }
    .espc-hero-desc         { font-size: 14px; }

    .espc-breadcrumb        { padding: 28px 0 0 0; }
    .espc-breadcrumb-inner  { padding: 0 32px; }
    .espc-inner             { padding: 0 32px; }

    .espc-section-content   { padding: 40px 0 0px 0; }
    .espc-content-grid      { flex-direction: column-reverse; gap: 24px; }
    .espc-content-left      { flex: none; width: 100%; }
    .espc-red-title         { font-size: 24px; margin-bottom: 14px; }
    .espc-para              { font-size: 14px; }
    .espc-slider-img-wrap   { height: 280px; }

    .espc-tabs-section      { padding: 40px 0 40px 0; }
    .espc-tabs-bar          { margin-bottom: 30px; }
    .espc-tab-active        { font-size: 14px; padding: 16px 12px; }
    .espc-tab-inactive      { font-size: 14px; padding: 16px 12px; }
    .espc-features-list li  { font-size: 14px; }
  }

  /* ══════════════════════════════════════════
     RESPONSIVE — MOBILE 480px
  ══════════════════════════════════════════ */
  @media (max-width: 480px) {
    .espc-hero              { height: 400px; }
    .espc-hero-bg           { display: none; }
    .espc-hero-bg-mobile    { display: block; }
    .espc-hero-content      { padding: 0 16px; }
    .espc-hero-title        { font-size: 24px; }
    .espc-hero-divider      { width: 100%; margin-bottom: 15px; }
    .espc-hero-desc         { font-size: 14px; }

    .espc-breadcrumb        { padding: 22px 0 0 0; }
    .espc-breadcrumb-inner  { padding: 0 16px; gap: 16px; }
    .espc-bc-item           { font-size: 14px; }
    .espc-bc-sep            { width: 18px; height: 18px; margin: 0 4px; }
    .espc-inner             { padding: 0 16px; }
    .espc-tab-icon          { width: 19px; height: 19px; }

    .espc-section-content   { padding: 30px 0 30px 0; }
    .espc-content-grid      { gap: 30px; }
    .espc-red-title         { font-size: 20px; margin-bottom: 16px; }
    .espc-para              { font-size: 14px; }
    .espc-slider-img-wrap   { height: 259px; }
    .espc-dot               { width: 5px; height: 5px; }

    .espc-tabs-section      { padding: 30px 0 60px 0; }
    .espc-tabs-bar          { flex-direction: row; }
    .espc-tab-active        { flex: none; font-size: 13px; padding: 14px 10px; width: 50%; }
    .espc-tab-active::after { display: none; }
    .espc-tab-inactive      { flex: none; font-size: 13px; padding: 14px 10px; width: 50%; }
    .espc-features-list li  { font-size: 14px; }
  }
`;

/* ── Tab Icons ── */
const FeaturesIcon = () => <img src={FeaturesTabIcon} alt="" className="espc-tab-icon" />;
const CubicleIcon  = () => <img src={CubicleTabIcon}  alt="" className="espc-tab-icon" />;

/* ── Render a feature line with optional bold segments ── */
const FeatureLine = ({ segments }) => (
  <>
    {segments.map((seg, i) =>
      seg.bold ? <b key={i}>{seg.text}</b> : <span key={i}>{seg.text}</span>
    )}
  </>
);

export default function EspControls() {
  const [activeSlide, setActiveSlide] = useState(0);
  const [activeTab,   setActiveTab]   = useState("features");
  const intervalRef  = useRef(null);
  const dragStartX   = useRef(null);

  /* ── Autoplay ── */
  const stopAutoplay = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };
  const startAutoplay = () => {
    stopAutoplay(); // always clear before starting — prevents interval stacking
    intervalRef.current = setInterval(() => {
      setActiveSlide(prev => (prev + 1) % SLIDES.length);
    }, AUTOPLAY_SPEED);
  };
  useEffect(() => {
    startAutoplay();
    return () => stopAutoplay();
  }, []);

  /* ── Dot click ── */
  const goToSlide = (i) => {
    stopAutoplay();
    setActiveSlide(i);
    startAutoplay();
  };

  /* ── Drag / swipe ── */
  const onDragStart = (e) => {
    dragStartX.current = e.type === "touchstart" ? e.touches[0].clientX : e.clientX;
    stopAutoplay();
  };
  const onDragEnd = (e) => {
    if (dragStartX.current === null) return;
    const endX = e.type === "touchend" ? e.changedTouches[0].clientX : e.clientX;
    const diff  = dragStartX.current - endX;
    if (Math.abs(diff) > 80) {
      setActiveSlide(prev =>
        diff > 0
          ? (prev + 1) % SLIDES.length
          : (prev - 1 + SLIDES.length) % SLIDES.length
      );
    }
    dragStartX.current = null;
    startAutoplay();
  };

  const tabs = [
    { key: "features", icon: <FeaturesIcon />, label: "Salient Features" },
    { key: "cubicle",  icon: <CubicleIcon />,  label: "Control Cubicle Options:" },
  ];

  return (
    <div className="espc-wrap">
      <style>{CSS}</style>

      {/* ══ 1. HERO ══ */}
      <section className="espc-hero">
        <img className="espc-hero-bg"        src={HeroBgImg}       alt="" />
        <img className="espc-hero-bg-mobile" src={HeroBgImgMobile} alt="" />
        <div className="espc-hero-overlay" />
        <div className="espc-hero-content">
          <h1 className="espc-hero-title">ESP Controls</h1>
          <hr className="espc-hero-divider" />
          <p className="espc-hero-desc">
            Our Third generation micro-controller for electrostatic precipitator applications helps regulate, monitor and optimize the electric power input to the ESP.
          </p>
        </div>
      </section>

      {/* ══ 2. BREADCRUMB ══ */}
      <nav className="espc-breadcrumb" aria-label="Breadcrumb">
        <div className="espc-breadcrumb-inner">
          <a href="/" className="espc-bc-item">Home</a>
          <span className="espc-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/products" className="espc-bc-item">Products</a>
          <span className="espc-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/products/esp-power-supplies" className="espc-bc-item">ESP Power Supplies</a>
          <span className="espc-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="espc-bc-item espc-active">ESP Controls</span>
        </div>
      </nav>

      {/* ══ 3. CONTENT ══ */}
      <section className="espc-section-content">
        <div className="espc-inner">
          <div className="espc-content-grid">

            {/* Left */}
            <div className="espc-content-left">
              <h2 className="espc-red-title">
                ESP Controls For 1-Phase / 3-Phase Applications
              </h2>
              <p className="espc-para">
                Our Third generation micro-controller based PRECICON-R Controller is not only a T/R controller, but also an ESP controller. The advanced Precicon-R for electrostatic precipitator applications helps regulate, monitor and optimize the electric power input to the ESP.
              </p>
            </div>

            {/* Right — slider */}
            <div className="espc-slider">
              <div
                className="espc-slider-img-wrap"
                onMouseDown={onDragStart}
                onMouseUp={onDragEnd}
                onMouseLeave={() => { dragStartX.current = null; startAutoplay(); }}
                onTouchStart={onDragStart}
                onTouchEnd={onDragEnd}
              >
                <div
                  className="espc-slider-track"
                  style={{ transform: `translateX(-${activeSlide * 100}%)` }}
                >
                  {SLIDES.map((src, i) => (
                    <img
                      key={i}
                      className="espc-slider-img"
                      src={src}
                      alt={`Slide ${i + 1}`}
                      draggable={false}
                    />
                  ))}
                </div>
              </div>
              <div className="espc-slider-dots">
                {SLIDES.map((_, i) => (
                  <button
                    key={i}
                    className={`espc-dot${activeSlide === i ? " espc-dot-active" : ""}`}
                    onClick={() => goToSlide(i)}
                    aria-label={`Slide ${i + 1}`}
                  />
                ))}
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ══ 4. TWO-TAB SECTION ══ */}
      <section className="espc-tabs-section">
        <div className="espc-inner">

          {/* Tab bar — 2 tabs */}
          <div className="espc-tabs-bar">
            {tabs.map(tab => (
              <button
                key={tab.key}
                className={activeTab === tab.key ? "espc-tab-active" : "espc-tab-inactive"}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.icon} {tab.label}
              </button>
            ))}
          </div>

          {/* Salient Features */}
          {activeTab === "features" && (
            <ul className="espc-features-list">
              {SALIENT_FEATURES.map((segments, i) => (
                <li key={i}><FeatureLine segments={segments} /></li>
              ))}
            </ul>
          )}

          {/* Control Cubicle Options */}
          {activeTab === "cubicle" && (
            <ul className="espc-features-list">
              {CUBICLE_OPTIONS.map((segments, i) => (
                <li key={i}><FeatureLine segments={segments} /></li>
              ))}
            </ul>
          )}

        </div>
      </section>

    </div>
  );
}